import React from 'react';
import { Link } from 'react-router-dom';
// import formatTableDate from '../../../lib/helpers/GeneralHelpers/formatTableDate';
// import getUsersFullName from '../../../lib/helpers/GeneralHelpers/getUsersFullName';
import Body from 'components/text/Body';

const columns = [
  {
    title: '_id',
    dataIndex: '_id',
    key: '_id',
    width: 130,
    render: _id => (
      <Link style={{ fontSize: 10 }} to={`/admin/dashboards/${_id}`}>
        {_id}
      </Link>
    ),
  },
  {
    title: 'name',
    render: (text, { name }) => <Body>{name}</Body>,
  },
  {
    title: 'dash Id',
    render: (text, { dashboardId }) => <Body>{dashboardId}</Body>,
  },
  {
    title: '',
    width: 50,
    render: (text, { icon }) => (icon ? <img height="70" src={icon} /> : null),
  },
  {
    title: 'filter',
    render: (text, { filterType }) => <Body>{filterType}</Body>,
  },
];

export default columns;



// WEBPACK FOOTER //
// ./src/routes/admin-dashboards/CustomDashboardsTable/columns.js